import { Component, OnInit, Input, EventEmitter, Output, PipeTransform, Pipe } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { special_keys } from '../../functions/shared-functions';
import { TalliteErrorStateMatcher } from '../../pipes/shared-pipes';


@Component({
  selector: 'app-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: ['./phone-number.component.scss']
})
export class PhoneNumberComponent implements OnInit {


  @Input() placeholder;
  @Input() type;
  @Input() value;
  @Input() id;
  @Input() style;
  @Input() class;
  @Input() label;
  @Input() hint;
  @Input() control_type;
  @Input() required;
  @Input() error_msg;
  @Input() form: UntypedFormGroup;
  @Input() controlName;
  @Input() disabled;
  @Input() readonly;
  @Input() maxLength = 16;
  @Input() minLength;
  @Input() label_block;
  @Input() data;
  @Input() pattern_desc = '^[0-9]*$';
  @Input() material_ui;
  @Input() float_label;
  @Input() hide_label;
  @Input() options;
  @Input() options_data;
  @Input() option_property = 'dial_code';
  @Input() option_title_property = 'name';
  @Input() option_selector = 'mobileNumberLength';
  @Input() func;
  @Input() option_form_control = 'mobileIsd'
  @Input() enable_whats_app_url;

  @Input() extra_controls_list = [];
  @Input() wa_control_name;

  @Input() alt_label;
  @Input() alt_placeholder;
  @Input() alt_dropcontrol_name;
  @Input() alt_control_name;
  @Input() alt_control_placeholder;
  @Input() phone_label;
  @Input() phone_dropcontrol_name;
  @Input() phone_control_name;
  @Input() design_pattern = 1;
  @Input() disabledDial = 1;
  @Input() addFunc;
  @Input() suffix_icon;
  @Input() suffix_tooltip;
  @Input() appearance;

  @Output() focusOut = new EventEmitter<any>()
  mobile_number_length = 12;
  matcher = new TalliteErrorStateMatcher()
  new_formControl = new UntypedFormControl();
  display_overlay = false;
  show_list = false;
  container_width = 200;
  left = 0;
  top = 0;


  random_id = 'tallint_number' + Math.floor((Math.random() * 10000) + 1) + Date.now();
  width = 200;

  constructor(
    private notification: NotificationService
  ) { }

  ngOnInit() {
    // if (this.form.get(this.controlName).value) {

    //   this.displayNumber(this.form.get(this.controlName).value);
    // }
    // console.log(this.form.get(this.controlName).value);
  }

  ngOnChanges(ev) {
    console.log(ev)
    if (ev && ev.minLength) {
      this.minLength = ev.minLength.currentValue;
    }
    if (ev && ev.maxLength) {
      this.maxLength = ev.maxLength.currentValue;

      if (this.maxLength < this.minLength) {
        this.minLength = this.maxLength;
      }
      if (!this.maxLength) {
        this.maxLength = 16;
      }
    }
    if (ev && ev.options) {
      this.options = ev.options.currentValue;
    }
    if (ev && ev.options_data) {
      this.options_data = ev.options_data.currentValue;
      if (this.options_data && this.options_data != '' && this.options && this.options.length) {
        this.options.forEach(op => {
          if (op[this.option_property] == this.options_data) {
            this.maxLength = op[this.option_selector];
            this.minLength = op[this.option_selector];
            this.form.controls[this.controlName].patchValue(this.form.controls[this.controlName].value)

          }
        })
      }
    }

    if (ev && ev.data) {
      this.data = ev.data.currentValue;
      if (this.data && this.data.length) {
        if (this.data.charAt(0) == 0) {
          this.data = this.data.replace(/^0+/, '')
          this.form.get(this.controlName).patchValue(this.data)
        }
      }
    }

    //
    // if (ev.data && ev.data.currentValue) {
    //   this.displayNumber(ev.data.currentValue.toString());
    // } else {
    //   this.new_formControl.reset();
    // }
    // if (ev.maxLength) {
    //   this.mobile_number_length = (ev.maxLength.currentValue) + 2;
    //   this.displayNumber(this.form.get(this.controlName).value);
    //   this.form.controls[this.controlName].patchValue(this.new_formControl.value);
    // }
  }


  inputNumber(evt: KeyboardEvent) {
    console.log(evt)
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    let pattern = '^[0-9]*$';
    let str = this.form.value[this.controlName];
    if (str && str.length) {
      if (str.charAt(0) == 0) {
        str = str.replace(/^0+/, '')
        this.form.get(this.controlName).patchValue(str)
      }
    }


    if (pattern && pattern != '' && (special_keys.indexOf(charCode) == -1) && !evt.ctrlKey && !evt.shiftKey && !evt.altKey) {
      let char = evt.key;
      try {
        let regex = new RegExp(pattern);
        if (regex.test(char)) {
          // event.target['value'] += event.key;
        }
        else {
          evt.preventDefault();
          return false
        }
      }
      catch (err) {
        return false;
      }
    }
    else {
      if (charCode == 9) {
        return true;
      }
      if ((charCode != 8) && (charCode != 37) && (charCode != 39)) {
        return false;
      }

    }
    return true;
  }
  // this.displayPhoneNumber(evt)
  // try {
  //   if (charCode == 13) {
  //     return false;
  //   }
  //   if (charCode == 8 || charCode == 9) {
  //     return true;
  //   }
  //   if (input.value.length == 0) {
  //     if (charCode == 96 || charCode == 48) {
  //       return false
  //     }
  //     else if (charCode < 31 || (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
  //       return true;
  //     }
  //     else {
  //       return false;
  //     }
  //   }
  //   else if (input.value.length >= this.mobile_number_length) {
  //     return false;
  //   }
  //   else if (input.value.length < this.mobile_number_length) {
  //     if (charCode < 31 || (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
  //       return true;
  //     }
  //     else {
  //       return false;
  //     }
  //   }

  // }
  // catch (error) {

  // }
  // finally {
  //   this.displayPhoneNumber(evt)
  // }
  // }


  displayNumber(str) {
    console.log(str)
    try {
      if (str) {
        str = str ? str.replace(/\-/g, '') : '';
        str = str ? str.replace(/ /g, '') : '';
        str = str ? str.replace(/\+/g, '') : '';
        str = str ? str.replace(/\(/g, '') : '';
        str = str ? str.replace(/\)/g, '') : '';
        str = str.replace(/\-/g, '');
        let a = str.slice(0, 3);
        let b = str.slice(3, 6);
        let c = str.slice(6, this.maxLength || 10);
        let out = '';
        if (a && a != '' && a.length == 3) {
          // a += '-';
        }
        out += a;
        if (b && b != '' && b.length) {
          // b = '-' + b
        }
        out += b;
        if (c && c != '' && c.length) {
          // c = '-' + c
        }
        out += c;

        this.new_formControl.setValue(out)
      }
      else {
        this.new_formControl.reset();
      }
    }
    catch (err) {
      this.new_formControl.reset();
    }
  }

  displayPhoneNumber(evt) {

    let charCode = (evt.which) ? evt.which : evt.keyCode;
    // if (evt.target.value && (evt.target.value.length == 4 || evt.target.value.length <= 8) && special_keys.indexOf(charCode) == -1) {
    //   if (evt.keyCode != 8 && evt.keyCode != 46) {
    //     this.new_formControl.setValue('-' + evt.target.value);
    //   }
    // }

    this.form.get(this.controlName).setValue((evt.target.value).split('-').join(''));
    // if (this.form.get(this.controlName).value.length > this.maxLength || 10) {
    //   this.form.get(this.controlName).setValue(String(this.form.get(this.controlName).value).slice(0, this.maxLength || 10));
    // }

    if (evt.keyCode != 8 && evt.keyCode != 46) {
      this.displayNumber(this.form.get(this.controlName).value);
    }

  }
  triggerEvent() {
    if (this.func) {
      try {
        this.func();
      }
      catch (err) {
        console.log(err)
      }
    }
    else {
      try {
        let req = {}
        req['mobileNumber'] = this.form.controls[this.controlName].value;
        req['mobileIsd'] = this.form.controls[this.option_form_control] && this.form.controls[this.option_form_control].value;
        if (this.form && this.form.controls[this.option_form_control].value && this.form.controls[this.controlName].valid) {
          // this.resume_srv.call(req).subscribe(res => {
          //   if (res && res['status']) {
          //     this.notification.success(res['message'], 'Close', 5000);
          //   }
          // })
        }
        else {
          this.notification.error('ERROR.please_enter_valid_mobile_to_dial', 'Close', 5000)
        }
      }
      catch (err) {
        console.log(err)
        let req = {}
        req['mobileNumber'] = this.form.controls[this.controlName].value;
        if (this.form.controls[this.controlName].valid) {
          // this.resume_srv.call(req).subscribe(res => {
          //   if (res && res['status']) {
          //     this.notification.success(res['message'], 'Close', 5000);
          //   }
          // })
        }
        else {
          this.notification.error('ERROR.please_enter_valid_mobile_to_dial', 'Close', 5000)
        }
      }

    }
  }
  focusOutEv(ev) {
    console.log(ev)
    if (ev) {
      this.focusOut.emit(this.form.get([this.controlName]).value)
    }
  }
  navigateToWhatsApp() {
    if (this.form.controls[this.controlName].valid && this.form.get([this.controlName]).value) {
      window.open('https://wa.me/' + (this.form.controls[this.option_form_control] && this.form.controls[this.option_form_control].value || '') + this.form.get([this.controlName]).value, "_blank")
    }
    else {
      this.notification.error('ERROR.please_enter_valid_mobile_to_whatsapp', 'Close', 5000)
    }
  }
  hideList() {
    this.show_list = false;
    this.display_overlay = false;
  }

  showList() {
    this.calculatePosition();
    this.display_overlay = true;
    this.show_list = true;
  }
  calculatePosition() {
    let top = document.getElementById(this.random_id).getBoundingClientRect().top;
    let left = document.getElementById(this.random_id).getBoundingClientRect().left;
    if (this.container_width == 200) {
      this.container_width = document.getElementById(this.random_id).offsetWidth;
      if (this.container_width <= 200) {
        this.container_width = 200;
      }
    }

    if (top > window.innerHeight / 2) {
      this.top = top - 195;
    }
    else {
      this.top = document.getElementById(this.random_id).getBoundingClientRect().top + 45;
    }
    if (left + 300 > (window.innerWidth)) {
      if (this.width) {
        this.left = window.innerWidth - 325 + 120;

      }
      else {
        this.left = window.innerWidth - 325;

      }
    }
    else {
      this.left = left;
    }
  }

  checkForTab(ev) {
    if (ev.key == 'Tab') {
      this.hideList();
    }
  }
  toggleWa(form_control) {
    if (this.form && this.form.get([form_control])) {
      this.form.get([form_control]).patchValue(this.form.get([form_control]).value ? 0 : 1)
    }
  }
}
@Pipe({
  name: "isValidControl",
})
export class isValidControl implements PipeTransform {
  transform(list, form, value) {
    console.log(value)
    console.log(list)
    console.log(form)
    try {
      if (list && list.length) {
        let i = list.findIndex(item => form.get([item.form_control]).value);
        if (i > -1) {
          return {
            'js-btn-success': true
          }
        }
        else {
          return {}
        }
      }
      else {
        return {}
      }
    }
    catch (err) {
      return {}
    }
  }
}
